import type { BillingStatusResponse } from "@/types/billingStatus";

import type { APIInstance } from "./apiService";

export class BillingStatusService {
  private api: APIInstance;

  constructor(api: APIInstance) {
    this.api = api;
  }

  async getBillingStatus(firmId: string): Promise<BillingStatusResponse> {
    const response = await this.api.get<BillingStatusResponse>(
      `/firms/${firmId}/payments/billing/status`
    );
    return response.data;
  }
}
